export enum OverrideCondition {
	Always = 0,
	FolderAttributeNotFilledOut = 1,
	IncomingAttributeFilledOut = 2,
}
